import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.dashboard');
import { AfterViewInit, OnInit, Input } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { Service } from "src/libs/portal/season/service";
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(...registerables, ChartDataLabels);
@Component({
    selector: 'wiz-page-admin-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.dashboard/view.scss */
.glass-card {
  background-color: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(16px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
  padding: 1.5rem;
  transition: all 0.2s;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.glass-card:hover {
  box-shadow: 0 30px 60px -12px rgba(0, 0, 0, 0.35), 0 10px 20px -5px rgba(0, 0, 0, 0.1);
  transform: scale(1.02);
}

.animate-gradient {
  background-size: 200% 200%;
  animation: gradientMove 2s ease-in-out infinite alternate;
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}`],
})
export class PageAdminDashboardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }
    @Input() title: any;
    public recentPairs: any[] = [];
    public total = '0';
    public answerTime = '0';
    public avgResponse = '0';
    public hourLabels: string[] = [];
    public hourData: number[] = [];
    public weekdayLabels: string[] = [];
    public weekdayData: number[] = [];
    public logs: any[] = [];
    public mergedLogs: any[] = [];
    public dateDataLabels: string[] = [];
    public dateDataCounts: number[] = [];
    public faqCount = 0;
    public chatCount = 0;

    public barChart: any;
    public faqChatChart: any;

    public pagenation: any = {
        page: 1,
        end: 1,
        start: 1,
    };

    public popularKeywords: any[] = []
    public loaded: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, '/login');
        await Promise.all([this.load(), this.loadRecentPairs()]);
    }

    public periods = [
        { label: "오늘", value: "today" },
        { label: "월별", value: "month" },
        { label: "반기별", value: "half" },
        { label: "연도별", value: "year" }
    ];
    public selectedPeriod = "today";
    public selectedMonth = "";
    public selectedHalf = "";
    public selectedYear = "";

    public months = [
        { label: "1월", value: "01" }, { label: "2월", value: "02" }, { label: "3월", value: "03" },
        { label: "4월", value: "04" }, { label: "5월", value: "05" }, { label: "6월", value: "06" },
        { label: "7월", value: "07" }, { label: "8월", value: "08" }, { label: "9월", value: "09" },
        { label: "10월", value: "10" }, { label: "11월", value: "11" }, { label: "12월", value: "12" }
    ];

    public halfOptions = [
        { label: "상반기(1~6월)", value: "first" },
        { label: "하반기(7~12월)", value: "second" }
    ];

    public years = (() => {
        const currentYear = new Date().getFullYear();
        const startYear = 2024;
        return Array.from({ length: currentYear - startYear + 1 }, (_, i) => (startYear + i).toString()).reverse();
    })();

    public selectedYear = new Date().getFullYear().toString();

    public async selectPeriod(period: string) {
        console.log('[selectPeriod]', period);
        this.selectedPeriod = period;
        this.selectedMonth = "";
        this.selectedHalf = "";
        
        if (period === 'today') {
            this.selectedYear = new Date().getFullYear().toString();
            await this.load();
            this.drawCharts();
        }
    }

    public async chooseMonth(month: string) {
        console.log('[chooseMonth]', month);
        this.selectedMonth = month;
    }

    public async chooseHalf(half: string) {
        this.selectedHalf = half;
    }

    public async chooseYear(year: string) {
        this.selectedYear = year;
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        
        const params: any = { page: this.pagenation.page, period: this.selectedPeriod };
        
        if (this.selectedPeriod !== 'today' && this.selectedYear) {
            params.year = this.selectedYear;
        }

        if (this.selectedPeriod === 'month' && this.selectedMonth)
            params.month = this.selectedMonth;
        if (this.selectedPeriod === 'half' && this.selectedHalf)
            params.half = this.selectedHalf;
            
        const { code, data } = await wiz.call("load", params);
        
        this.total = Number(data.total_questions || 0).toLocaleString("ko-KR");
        this.logs = data.logs || [];
        this.answerTime = data.answer_rate || 0;
        this.avgResponse = data.avg_ttft || 0;
        this.hourLabels = data.hour_labels || [];
        this.hourData = data.hour_data || [];
        this.weekdayLabels = data.weekday_labels || [];
        this.weekdayData = data.weekday_data || [];
        this.popularKeywords = data.keywords || [];
        this.dateDataLabels = (data.date_data || []).map((item: any) => item.date);
        this.dateDataCounts = (data.date_data || []).map((item: any) => item.count);
        this.faqCount = data.faq_count || 0;
        this.chatCount = data.chat_count || 0;
        
        this.loaded = true;
        await this.service.render();
        this.drawCharts();
    }

    private drawCharts(): void {
        const barCanvas = document.getElementById('barChart') as HTMLCanvasElement;
        const faqChatCanvas = document.getElementById('faqChatChart') as HTMLCanvasElement;

        if (!barCanvas || !faqChatCanvas) return;

        if (this.barChart) this.barChart.destroy();
        if (this.faqChatChart) this.faqChatChart.destroy();

        this.barChart = new Chart(barCanvas, {
            type: 'bar',
            data: {
                labels: this.hourLabels,
                datasets: [{
                    label: '요청 수',
                    data: this.hourData,
                    backgroundColor: '#475569',
                    borderColor: '#334155',    
                    borderWidth: 1,
                    borderRadius: 4,
                    hoverBackgroundColor: '#2563EB',
                    hoverBorderColor: '#1E40AF'
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    datalabels: { display: false }
                },
                scales: {
                    y: { beginAtZero: true, grid: { color: '#E2E8F0' }, ticks: { color: '#64748B' } },
                    x: { grid: { color: '#E2E8F0' }, ticks: { color: '#64748B' } }
                }
            }
        });

        this.faqChatChart = new Chart(faqChatCanvas, {
            type: 'pie',
            data: {
                labels: ['FAQ', '채팅'],
                datasets: [{
                    data: [this.faqCount, this.chatCount],
                    backgroundColor: ['#475569', '#2563EB'],
                    borderColor: ['#334155', '#1E40AF'],
                    borderWidth: 2
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: { color: '#374151', font: { size: 12, weight: 'bold' }, padding: 10 }
                    },
                    datalabels: {
                        color: '#FFFFFF',
                        font: { weight: 'bold', size: 14 },
                        formatter: (value, context) => {
                            const total = context.dataset.data.reduce((a: any, b: any) => a + b, 0);
                            if (total === 0) return '0%';
                            return (value / total * 100).toFixed(1) + '%';
                        }
                    }
                }
            }
        });
    }

    public async alert(message: string, title: any = "", status: any = "error", action: string = '확인', cancel: any = false) {
        return await this.service.alert.show({
            title: title,
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public async loadRecentPairs() {
        const res = await wiz.call("load_recent_pairs");
        this.recentPairs = Array.isArray(res?.data?.data) ? res.data.data : [];
        console.log('[pairs]', this.recentPairs.length, this.recentPairs);
        await this.service.render();
    }

    public goToLogPage(threadId?: string) {
        if (threadId) {
            window.location.href = `/log?thread_id=${encodeURIComponent(threadId)}`;
        } else {
            window.location.href = `/log`;
        }
    }
}

export default PageAdminDashboardComponent;